import { Table } from "./types";

export const TableActions = {
    StartEditingCell: () => ({ type: Table.START_CELL_EDIT }),
    StopEditingCell: () => ({ type: Table.STOP_CELL_EDIT }),
    SetSelectedRow: (node) => ({
        type: Table.SET_SELECTED_NODE,
        node,
    }),
    SetColumnState: (columnState) => ({
        type: Table.SET_COLUMN_STATE,
        columnState,
    }),
};
